export const CLASSROOM_SORTS = {
  teacher: 'teacher',
  name: 'name',
};

// classrooms without a teacher sort after named teachers
const LAST = '￿';

// Teacher (default): the logged-in teacher's classrooms first, then other teachers'
// grouped by teacher name, then classroom name. Name: classroom name only.
export const sortClassrooms = (
  classrooms,
  { sort = CLASSROOM_SORTS.teacher, loggedInUserId, getTeacherName }
) => {
  const byName = (a, b) => a.chatName.localeCompare(b.chatName);
  if (sort === CLASSROOM_SORTS.name) return [...classrooms].sort(byName);

  const isMine = (classroom) => classroom.teacherId === loggedInUserId;
  const teacherName = (classroom) =>
    (classroom.teacherId && getTeacherName(classroom.teacherId)) || LAST;

  return [...classrooms].sort(
    (a, b) =>
      isMine(b) - isMine(a) ||
      teacherName(a).localeCompare(teacherName(b)) ||
      byName(a, b)
  );
};
